import gql from 'graphql-tag';
import { paycheckLineTemplateFragments } from './paycheckLineTemplateFragments';

export const UPDATE_PAYCHECK_LINE_TEMPLATE = gql`
  mutation updatePaycheckLineTemplate(
    $paycheckLineTemplates: [PaycheckLineTemplateUpdate!]!,
  ) {
    updatePaycheckLineTemplate(
      input: {
        paycheckLineTemplates: $paycheckLineTemplates,
      }
    ) {
      paycheckLineTemplates {
        ...paycheckLineTemplateFragments
      }
    }
  },
  ${paycheckLineTemplateFragments}
`;

export const GET_WORK_RELATION_PAYCHECK_LINE_TEMPLATES = gql`
  query getWorkRelationPaycheckLineTemplates($id: ID!, $editableFromEmployeePage: Boolean) {
    workRelation(id: $id) {
      id
      startDate
      endDate
      employmentType
      occupation {
        id
        name
      }
      employee {
        id
        firstName
        lastName
      }
      subUnit {
        id
        name
      }
      paycheckLineTemplates(editableFromEmployeePage: $editableFromEmployeePage) {
        ...paycheckLineTemplateFragments
      }
    }
  }
  ${paycheckLineTemplateFragments}
`;
